global css html
	ff:Ubuntu, sans
	button ff:Ubuntu fs:md py:1em px:2em mt:1em bw:0 bg:#0077ff c:gray0 rd:15px bxs:sm
	button@hover bg:#005fcc
	button@active transform:translateY(2px) bxs:xxs

const checkIfEmail = do(emailStr) 
	let emailregex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
	return emailregex.test(emailStr)

const showSuccessMsg = do(idToChange)
	let successCopy = "Please only enter a valid email"
	document.getElementById(idToChange).innerHTML = successCopy
	imba.commit()

const showInvalidMsg = do(idToChange)
	let invalidCopy = "Thank you, a confirmation email has been sent"
	document.getElementById(idToChange).innerHTML = invalidCopy
	imba.commit()

const submitEmail = do(textboxIdToTake, labelToChange)
	let userInputTextbox = document.getElementById(textboxIdToTake)
	let userInput = userInputTextbox.value
	checkIfEmail(userInput) ? showSuccessMsg(labelToChange) : showInvalidMsg(labelToChange)
	userInputTextbox.reset()


tag invitation
	<self>
		<div>
			css ta:center bs:solid bw:3 bc:black rd:15px mx:17% bgc:cooler2 mt:5em bxs:xxl p:1em min-width:250px
			css input mt:1em bs:solid bw:2 bc:black w:16em rd:5px
			<h2> "Logos Audio is being constructed"
			<br />
			<p> "Provide your email to receive updates on our progress"
			<div id="mc_embed_signup">
				<form action="https://audio.us5.list-manage.com/subscribe/post?u=da1522758dcd3b8dd7ce90fcf&amp;id=c3a9c8ce27" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" .validate target="_blank" novalidate>
					<div id="mc_embed_signup_scroll">
						<div .mc-field-group>
							<input [ta:center w:49% h:5%] type="email" placeholder="Email address" autocomplete="off" name="EMAIL" .required.email id="mce-EMAIL">
						<div id="mce-responses" .clear>
							<div .response id="mce-error-response" [display:none]>
							<div .response id="mce-success-response" [display:none]>
						<div [position: absolute; left: -5000px;] aria-hidden="true">
							<input type="text" name="b_da1522758dcd3b8dd7ce90fcf_c3a9c8ce27" tabindex="-1" value="">
						<div .clear>
							<input [ff:Ubuntu fs:md py:1em px:2em mt:1em bw:0 bg:#0077ff c:gray0 rd:15px bxs:sm bg@hover:#005fcc transform@active:translateY(2px)] type="submit" value="Submit" name="subscribe" id="mc-embedded-subscribe" .button>


tag app
	<self>
		<nav [display:flex flex-direction:row flex-direction:row]>
			<img[w:150px h:auto flex:1] src='./lalogo.png'>
			<button [c:white my:1em mx:2.1em flex:2] type="button" @click=(document.location='./key.asc.txt')> "PGP key"
			<button [c:white my:1em mx:2.1em flex:2] type="button" @click=(document.location='https://linkedin.com/in/matthew-pagan')> "LinkedIn"
			<button [c:white my:1em mx:2.1em flex:2] type="button" @click=(document.location='https://github.com/mttpgn')> "Github"
			<button [c:white my:1em mx:2.1em flex:2] type="button" @click=(document.location='https://medium.com/@mttpgn')> "Medium"
		<hr>
		<div [ta: center]>
			<h1> "Logos Audio"
			<p> "“Speak and be heard”"



imba.mount <app>
imba.mount <invitation>
